import { Button, Input, Modal, Row, Space } from "antd";
import { useState } from "react";
import dayjs from "dayjs";
import range from "helpers/range";
import useUpdate from "hooks/useUpdate";

import InputDate from "components/InputDate";
import TaskColorPicker from "components/TaskColorPicker";

const disabledDateTime = () => ({
  disabledMinutes: () => [
    ...range(1, 15),
    ...range(16, 30),
    ...range(31, 45),
    ...range(46, 60),
  ],
});

const EditTask = ({ handleConfirm, refetch, task, close }) => {
  const [content, setContent] = useState(task.content);
  const [status_color, setStatusColor] = useState(task.status_color);
  const [date, setDate] = useState(task.date);

  const { is_saving, update } = useUpdate({
    path: `/tasks/${task.id}`,
    onSuccess: () => {
      close();
      refetch();
      handleConfirm();
    },
  });

  const handleSubmit = async () =>
    update({
      status_color,
      content,
      date,
    });

  return (
    <Modal
      width={700}
      open
      title="Edytuj priorytet"
      footer={null}
      id="day_modal"
      onCancel={close}
    >
      <Input.TextArea
        value={content}
        style={{ marginBottom: 30 }}
        onChange={({ target: { value } }) => setContent(value)}
        rows={7}
        maxLength={400}
        showCount={true}
      />
      <InputDate
        format="DD-MM-YYYY HH:mm"
        showTime={{ format: "HH:mm" }}
        disabledTime={disabledDateTime}
        defaultValue={dayjs(date)}
        onChange={(a) => setDate(a)}
        style={{ marginBottom: 20 }}
        getPopupContainer={() => document.querySelector("#day_modal")}
      />
      <TaskColorPicker active_color={status_color} setColor={setStatusColor} />
      <Row justify="end">
        <Space>
          <Button onClick={close}>Anuluj</Button>
          <Button
            type="primary"
            htmlType="button"
            onClick={handleSubmit}
            disabled={!content || !date || is_saving}
            loading={is_saving}
          >
            Zapisz
          </Button>
        </Space>
      </Row>
    </Modal>
  );
};

export default EditTask;
